export default "__VITE_ASSET__DI9N$Qkk__"